import { useEffect, useRef, useState } from 'react';
import { useContent } from '@/services/siteData';

export function HeroSlider() {
  const slides = useContent().slides;
  const [i, setI] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const start = () => {
    timer.current = setInterval(() => setI((p) => (p + 1) % slides.length), 5000);
  };

  useEffect(() => {
    start();
    return () => {
      if (timer.current) clearInterval(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slides.length]);

  const jump = (n: number) => {
    setI(n);
    if (timer.current) clearInterval(timer.current);
    start();
  };

  return (
    <div className="slider">
      {slides.map((src, n) => (
        <div key={n} className={'slide' + (n === i ? ' is-active' : '')} style={{ backgroundImage: `url(${src})` }} />
      ))}
      <div className="slider-dots">
        {slides.map((_, n) => (
          <button key={n} className={'dot' + (n === i ? ' is-active' : '')} onClick={() => jump(n)} aria-label={`Slide ${n + 1}`} />
        ))}
      </div>
    </div>
  );
}
